import { Box, Typography } from "@mui/material";
import { useInterestsTable } from "../../hooks/interests/interests-table.hook";
import DataTable from "@/modules/common/components/tables/data-table";
import { interestsColumns } from "../../constants/interests-columns";
import { InterestssTableContext } from "../../contexts/interests-table.context";

export default function InterestsTab({ propertyUid }: { propertyUid: string }) {
  const {
    data: interests,
    defaultColumnVisibility,
    pagination,
    setPagination,
    defaultPagination,
    isLoading,
    isError,
    rowCount,
    sorting,
    setSorting,
    selectedRows,
    filters,
    setFilters,
    handleSearch,
    handleDeleteFilter,
    handleClearAllFilters,
    syncFiltering,
    handleRowClick,
  } = useInterestsTable({ propertyUid });

  return (
    <InterestssTableContext.Provider
      value={{
        rowCount,
        rowsLoading: isLoading,
        selectedRows,
        filters,
        setFilters,
        handleSearch,
        handleDeleteFilter,
        handleClearAllFilters,
        syncFiltering,
      }}
    >
      <Box
        sx={(t) => ({
          display: "flex",
          flexDirection: "column",
          gap: t.nawy.spacing.md,
          height: "100%",
        })}
      >
        {/* TOP BAR */}
        <Box
          sx={(theme) => ({
            backgroundColor: theme.nawy.colors.semantic.layer.primary,
          })}
        >
          <Box
            sx={(theme) => ({
              p: theme.nawy.spacing.md,
              // pb: 0,
              display: "flex",
              justifyContent: "space-between",
            })}
          >
            <Box
              sx={(theme) => ({
                display: "flex",
                gap: theme.nawy.spacing.xs,
                flex: 1,
                alignItems: "center",
              })}
            >
              <Typography
                sx={(theme) =>
                  theme.nawy.typography.english.variants.headline.sm
                }
              >
                Interests
              </Typography>
            </Box>
          </Box>
          {/* <InterestTableFilters /> */}
        </Box>

        <Box
          sx={(t) => ({
            backgroundColor: t.nawy.colors.semantic.layer.primary,
          })}
        >
          <DataTable
            name="Interests"
            height="50vh"
            width="100%"
            columns={interestsColumns}
            data={interests?.results}
            type="server"
            rowCount={rowCount}
            pagination={pagination}
            setPagination={setPagination}
            sorting={sorting}
            setSorting={setSorting}
            showTopBar={false}
            isLoading={isLoading}
            onRowClick={handleRowClick}
            tableLayout="full"
            getRowId={(row) => row.uid}
            enableColumnResizing={false}
            enableRowSelection={false}
            initialState={{
              columnVisibility: defaultColumnVisibility,
              pagination: defaultPagination,
            }}
            isError={isError}
          />
        </Box>
      </Box>
    </InterestssTableContext.Provider>
  );
}
